import { Area, Bar, Line, Pie, Radar } from 'recharts';

Bar.defaultProps = { ...Bar.defaultProps, isAnimationActive: false };
Line.defaultProps = { ...Line.defaultProps, isAnimationActive: false };
Area.defaultProps = { ...Area.defaultProps, isAnimationActive: false };
Pie.defaultProps = { ...Pie.defaultProps, isAnimationActive: false };
Radar.defaultProps = { ...Radar.defaultProps, isAnimationActive: false };
